import PropTypes from 'prop-types';
import React from 'react';

const IconArrow = ({ className }) => (
  <svg
    width="20"
    height="7"
    viewBox="0 0 20 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.0433 6.7C15.3233 6.10267 15.5939 5.58 15.8553 5.132C16.1353 4.684 16.4059 4.31067 16.6673 4.012H0.34325V2.836H16.6673C16.4059 2.51867 16.1353 2.136 15.8553 1.688C15.5939 1.24 15.3233 0.726666 15.0433 0.147999H16.0233C17.1993 1.51067 18.4313 2.51867 19.7193 3.172V3.676C18.4313 4.31067 17.1993 5.31867 16.0233 6.7H15.0433Z"
      fill="white"
    />
  </svg>
);

IconArrow.propTypes = {
  className: PropTypes.string,
};
IconArrow.defaultProps = {
  className: '',
};

export default IconArrow;
